import React from 'react';
import styles from './styles.module.scss';

export interface CircleIconButtonProps {
  /** IcoMoon glyph name without the `icon-` prefix (e.g. `chevron-left`). */
  icon: string;
  ariaLabel: string;
  onClick: () => void;
  /** Visual diameter: `sm` = 28px, `md` = 32px. The hit area is always ≥40px. */
  size?: 'sm' | 'md';
  /** `circle` (default) or `square` with 6px corners. */
  shape?: 'circle' | 'square';
  disabled?: boolean;
  ariaExpanded?: boolean;
  testId?: string;
}

/**
 * Round icon-only button on a hairline fill (pager arrows, month navigation,
 * collapse-all). An invisible `::before` extends the touch target past the
 * visual circle so small sizes still meet the 40px hit-area minimum.
 */
export const CircleIconButton: React.FC<CircleIconButtonProps> = ({
  icon,
  ariaLabel,
  onClick,
  size = 'md',
  shape = 'circle',
  disabled = false,
  ariaExpanded,
  testId,
}) => (
  <button
    type="button"
    className={`${styles.button} ${styles[size]}${shape === 'square' ? ` ${styles.square}` : ''}`}
    aria-label={ariaLabel}
    aria-expanded={ariaExpanded}
    disabled={disabled}
    onClick={onClick}
    data-testid={testId}
  >
    <i className={`icon-${icon}`} aria-hidden="true" />
  </button>
);

export default CircleIconButton;
